import { RootState } from '@app/redux/store';

export const getShops = (state: RootState) => state.fastOrder.shops;
export const getFilterShops = (state: RootState) => state.fastOrder.filterShops;
export const getHistoryShops = (state: RootState) => state.fastOrder.historyShops;
export const getCurrentShop = (state: RootState) => state.fastOrder.currentShop;
export const getIsLoadedShops = (state: RootState) => state.fastOrder.isLoadedShops;
export const getIsAddDistance = (state: RootState) => state.fastOrder.isAddDistance;
export const getIsHideShopTwoHours = (state: RootState) => state.fastOrder.isHideShopTwoHours;
export const getTransferredShopId = (state: RootState) => state.fastOrder.transferredShopId;
export const getOpenShopId = (state: RootState) => state.fastOrder.openShopId;
